import { useViewPort } from "@website/hooks/viewport";
import { usePopoverFull } from "@website/ui/popover-full/popover-full.hook";
import styles from "@website/ui/popover-full/popover-full.module.scss";
import { PopoverFullPropertiesType } from "@website/ui/popover-full/popover-full.types";
import { TransitionV2 } from "@website/ui/transition";
import { FC, memo } from "react";

const PopoverFull: FC<PopoverFullPropertiesType> = (properties) => {
  const {
    animate,
    children,
    title,
    position,
    StartAction,
    EndAction,
    gapHorizontal,
    gapVertical,
    className
  } = properties;
  const { rootProps, transitionProps, popoverOpen, animateOpen } =
    usePopoverFull(properties);
  const { isMobile } = useViewPort();

  if (popoverOpen) {
    return (
      <TransitionV2 {...transitionProps} in={animateOpen}>
        {(state) => (
          <div
            {...rootProps}
            className={`${styles["popover-full"]} ${className} ${
              styles[position || "start"]
            } ${
              animate === "normal"
                ? ""
                : `${styles["animate"]} ${
                    state === "entering" || state === "entered"
                      ? styles["animate-enter"]
                      : styles["animate-exit"]
                  }`
            } `}
            style={{
              marginBlockStart: isMobile ? "0px" : gapVertical || "0px",
              ...(position === "start"
                ? {
                    marginInlineStart: isMobile ? "0px" : gapHorizontal || "0px"
                  }
                : {
                    marginInlineEnd: isMobile ? "0px" : gapHorizontal || "0px"
                  })
            }}
          >
            {StartAction || title || EndAction ? (
              <div className={styles["header"]}>
                {StartAction}
                <div className={styles["title"]}>{title}</div>
                {EndAction}
              </div>
            ) : null}
            <div className={`${styles["main"]}`}>{children}</div>
          </div>
        )}
      </TransitionV2>
    );
  }
  return null;
};

const PopoverFullMemoized = memo(PopoverFull);
export { PopoverFullMemoized as PopoverFull };
